var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isShow && (!_vm.user.vip || _vm.user.payLevel != 1)
    ? _c(
        "div",
        { staticClass: "floating", attrs: { id: "freeSaledFloating" } },
        [
          _c("div", { staticClass: "floating-content" }, [
            _c("div", {
              staticClass: "default-close freesale-close",
              on: {
                click: function($event) {
                  return _vm.openDialog(2)
                }
              }
            }),
            _vm._v(" "),
            _c("div", {
              staticClass: "freesale-body",
              on: {
                click: function($event) {
                  return _vm.openDialog(1)
                }
              }
            })
          ]),
          _vm._v(" "),
          _c("freeSaledDialog", { ref: "freeSaledDialog" })
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-57476a7c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-57476a7c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/floating/free_saled_floating.vue
// module id = null
// module chunks = 